import Vue from 'vue'
import App from './App.vue'
import VueRouter from  'vue-router'
import router from './router'// loads from src/router/index.js
Vue.config.productionTip = false

Vue.prototype.$cmCurrentSessiondata = window.cmCurrentSessiondata;
Vue.use(VueRouter)

new Vue({
  router,
  render: h => h(App),
}).$mount('#appCurrentSession')
